import React from 'react';
import {Link as NewLinl, withRouter} from 'react-router-dom';
import {ONLINE_WORKSHOPS} from 'stores/WorkshopsUrlConstants';
import HttpClient from 'services/HttpClient';
import moment from 'moment';
import Scroll from 'react-scroll';
import {inject} from 'mobx-react'
import NO_AVA from 'styles/img/no-ava-card.png';
import ragularPreview from 'styles/img/svg-set/index-regular-workshop.svg'
import webinar_icon from 'styles/img/webinar_icon.jpg';
import logo_2 from '../styles/img/organizations/logo_2.png';
import logo_2x from '../styles/img/organizations/logo_2@2x.png';
import logo_3x from '../styles/img/organizations/logo_2@3x.png';
let Link   = Scroll.Link;
let Element = Scroll.Element;
// const INDEX = '/api/v1/workshops';
const INDEX = '/api/v1/workshops/in_person';
const INDEX_WORKSHOPS = '/api/v1/workshops/online_list';
const INDEX_WEBINARS = '/api/v1/workshops/online/?&workshop_types[]=2&page=1';
const INDEX_ONLINE = '/api/v1/workshops/online/?&workshop_types[]=1&page=1';
const INDEX_GROUP = '/api/v1/workshops/online/?&workshop_types[]=3&page=1';
const INDEX_PUBLIC = '/api/v1/workshops/online/?&workshop_types[]=5&page=1';

@withRouter
@inject('user')
export default class Index extends React.Component {

  state = {michael: [], online: [], regular: [], workshops: [], webinars: [], online: [], group: [], public: []} ;

  componentWillMount = () => {
    new HttpClient().get(INDEX).then(data => {
      const onlyThree = data.body.data.workshops.slice(0, 3);
      this.setState({regular: onlyThree});
    });
    // new HttpClient().get(INDEX_WORKSHOPS).then(data => {
    //   this.setState({workshops: data.body.data.workshops});
    // });
    new HttpClient().get(INDEX_WEBINARS).then(data => {
      const onlyThree = data.body.data.workshops.slice(0, 3);
      this.setState({webinars: onlyThree});
    });
    new HttpClient().get(INDEX_ONLINE).then(data => {
      const onlyThree = data.body.data.workshops.slice(0, 3);
      this.setState({online: onlyThree});
    });
    new HttpClient().get(INDEX_GROUP).then(data => {
      const onlyThree = data.body.data.workshops.slice(0, 3);
      this.setState({group: onlyThree});
    });
    new HttpClient().get(INDEX_PUBLIC).then(data => {
      const onlyThree = data.body.data.workshops.slice(0, 3);
      this.setState({public: onlyThree});
    });
  };

  redirectToOnline = (id) => {
    this.props.history.push('/details/online/' + id)
  };

  redirectToRegular = (id) => {
    this.props.history.push('/details/regular/' + id)
  };

  redirectWebinar = () => {
    if(this.props.user.userLoggedIn()) {
      this.props.history.replace('/webinars');
    } else {
      this.props.history.replace('/online_workshops', {webinar: true});
    }
  };

  redirectOnline = () => {
    if(this.props.user.userLoggedIn()) {
      this.props.history.replace('/online');
    } else {
      this.props.history.replace('/online_workshops', {online: true});
    }
  }

  redirectGroup = () => {
    if(this.props.user.userLoggedIn()) {
      this.props.history.replace('/public_webinars');
    } else {
      this.props.history.replace('/online_workshops', {group: true});
    }
  }

  redirectToPublic = () => {
    if(this.props.user.userLoggedIn()) {
      this.props.history.replace('/public_workshops');
    } else {
      this.props.history.replace('/online_workshops', {public: true});
    }
  }

  redirectContactUs = () => {
    this.props.history.push('/contacts');
  }

  shortDescription = (description) => {
    let substrIndex = 100, new_description = description.substr(0, substrIndex);
    if (description.length > substrIndex)
      new_description += ' ...'
    return new_description
  }

  render(){
    return(
      <main className="main-content">
        {/* <section className="invest">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                <div className="invest-inner">
                  <div className="invest-holder">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 786.3 426">

                      <path d="M502.9 364.6l20.8-12c13.6-7.9 18.3-25.3 10.4-38.9l-12-20.8c-7.9-13.6-25.3-18.3-38.9-10.4l-20.8 12c-13.6 7.9-18.3 25.3-10.4 38.9l12 20.8c7.9 13.6 25.3 18.2 38.9 10.4zM283.4 364.6l-20.8-12c-13.6-7.9-18.3-25.3-10.4-38.9l12-20.8c7.9-13.6 25.3-18.3 38.9-10.4l20.8 12c13.6 7.9 18.3 25.3 10.4 38.9l-12 20.8c-7.9 13.6-25.3 18.2-38.9 10.4z"
                            className="st0"/>
                      <path d="M282.1 343c0 35.3 28.7 64 64 64h94c35.3 0 64-28.7 64-64v-59c0-35.3-28.7-64-64-64h-94c-35.3 0-64 28.7-64 64v59z"
                            className="st0"/>
                      <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 15.9-7.1 30.5-19 42.1v.5l47 47 47-47v-.5c-11.8-11.6-19-26.2-19-42.1z"
                            className="st1"/>
                      <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 4.5-.6 8.8-1.6 13l19.2 11.6c6.4 3.9 14.5 3.9 20.9 0l19.2-11.6c-1.1-4.2-1.7-8.5-1.7-13z"
                            className="st2"/>
                      <path d="M433.5 176l-29.9 18.1c-6.4 3.9-14.5 3.9-20.9 0L352.8 176c-9.6-5.8-15.7-15.9-16.5-27.1L329.1 48h128L450 148.9c-.8 11.2-7 21.3-16.5 27.1z"
                            className="st3"/>
                      <path d="M410.1 137.5l16-1M360.1 136.5l16 1" className="st4"/>
                      <path d="M132.6 421h521" className="st5"/>
                      <path d="M452.4 114.9l4.7-67h-128l5.8 81.1c4-3.5 8.6-6.4 13.6-8.6 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 .1.1 19.9 8.8 32.3 25.5z"
                            className="st6"/>
                      <path d="M411.1 12c-59-24-99 31.8-99 81 0 15.3 3.9 29.7 10.7 42.3 4.8-10.9 14.1-19.8 25.7-24.8 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 0 0 40 17.5 42 50.9.3 4.3 1.5 8.4 1.8 12.5 11.2-12.7 18.2-30.5 18.2-50.3 0-19.6-10-80.6-71-80.6z"
                            className="st7"/>
                      <path d="M268.3 387c0 11 9 20 20 20H498c11 0 20-9 20-20V255c0-11-9-20-20-20H288.3c-11 0-20 9-20 20v132z"
                            className="st8"/>
                      <circle cx="393.1" cy="321" r="24" className="st9"/>
                      <path d="M271.6 398c3.6 5.4 9.7 9 16.7 9H498c7 0 13.1-3.6 16.7-9H271.6z"
                            className="st10"/>
                      <path d="M201.1 88.2l-39 28.6c-3 2.2-7.3.1-7.3-3.7V55.9c0-3.8 4.3-5.9 7.3-3.7l39 28.6c2.5 1.8 2.5 5.6 0 7.4zM89.7 84.5h35.8M219.9 54.5h16M690.6 198.7h-17.4v-17.4c0-4.6-3.8-8.4-8.4-8.4H652c-4.6 0-8.4 3.8-8.4 8.4v17.4h-17.4c-4.6 0-8.4 3.8-8.4 8.4V220c0 4.6 3.8 8.4 8.4 8.4h17.4v17.4c0 4.6 3.8 8.4 8.4 8.4h12.9c4.6 0 8.4-3.8 8.4-8.4v-17.4h17.4c4.6 0 8.4-3.8 8.4-8.4v-12.9c-.1-4.6-3.9-8.4-8.5-8.4zM783.3 213.6h-52.8M746.4 183.6h-29.6M84.5 298.4l34-75M152.5 298.4l-34-75M98 269h41"
                            className="st11"/>
                      <g>
                        <path d="M170 260.9h32M186 244.9v32" className="st11"/>
                      </g>
                      <path d="M80 234H49M60 264H3M63 114.5h62.5M601.5 33.5L625 57M679 3l-54 54M552 134l50.5-50.5M560 86l22.5-22.5"
                            className="st11"/>
                    </svg>
                    <div className="shadow"/>
                  </div>
                  <p className="invest-slogan">CONTINUOUS PROFESSIONAL DEVELOPMENT (CPD) FOR ALL THERAPISTS</p>
                  <h2 className="invest-title">invest in yourself</h2>
                  <ul className="invest-professions">
                    <li>Over 5,000 therapist members</li>
                  </ul> */}
                  {/* <ul className="invest-professions">
                    <li>Counsellors</li>
                    <li>Psychotherapists</li>
                    <li>Psychologists</li>
                    <li>Psychiatrists</li>
                    <li>Supervisors</li>
                  </ul>
                  <p className="invest-hours">ACHIEVE CPD HOURS</p>
                  <div className="invest-btn-holder">
                    <NewLinl to={ONLINE_WORKSHOPS} className="btn prime bordered">ONLINE WORKSHOPS</NewLinl>
                    <NewLinl to="/regular_workshops" className="btn bordered blue">REGULAR WORKSHOPS</NewLinl>
                  </div>
                  <Link to="online" spy={true} smooth={true} offset={50} duration={500}>
                    <span className="invest-down-page ic-arrow-down-ico" />
                  </Link> */}
                  {/* <ul className="top-socials">
                    <li><a href="https://www.facebook.com/TherapyAcademy/" target="_blank" className="fa fa-facebook"/></li>
                    <li><a href="https://twitter.com/academy_therapy" target="_blank" className="fa fa-twitter"/></li>
                    <li><a href="https://www.linkedin.com/company/11230117" target="_blank" className="fa fa-linkedin"/></li>
                    <li><a href="https://www.linkedin.com/company/11230117" target="_blank" className="fa fa-instagram"/></li>
                  </ul> */}
                {/* </div>
              </div>
            </div>
          </div>
        </section> */}

        <section className="invest home_bg sections ">
          <div className="hero__content home_hero_content">
            <div className="hero__block">
              <div className="hero__logo">
                <img src={logo_2} srcSet={`${logo_2x} 2x, ${logo_3x} 3x`} alt="TherapyAcademy" />
              </div>
              <div>
                <h2 className="invest-title">invest in yourself</h2>
                <p className="invest-slogan">CONTINUOUS PROFESSIONAL DEVELOPMENT (CPD) FOR ALL MENTAL HEALTH PRACTITIONERS</p>
                <ul className="invest-professions">
                  <li>Over 5,000 members</li>
                </ul>
                <div className="workshop-all">
                  <span onClick={this.redirectContactUs} className="btn prime bordered">Join our mailing list</span>
                </div>
              </div>
            </div>
          </div>
          <ul className="top-socials">
            <li><a href="https://www.facebook.com/TherapyAcademy/" target="_blank" className="fa fa-facebook"/></li>
            <li><a href="https://twitter.com/academy_therapy" target="_blank" className="fa fa-twitter"/></li>
            <li><a href="https://www.linkedin.com/company/therapy-academy/" target="_blank" className="fa fa-linkedin"/></li>
            <li><a href="https://www.instagram.com/therapyacademy.ie/" target="_blank" className="fa fa-instagram"/></li>
          </ul>
        </section>

        {/* Webinars */}
        <section className="main-workshops">
          <div className="container-fluid">
            <div className="invest-holder">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 786.3 426">

                <path d="M502.9 364.6l20.8-12c13.6-7.9 18.3-25.3 10.4-38.9l-12-20.8c-7.9-13.6-25.3-18.3-38.9-10.4l-20.8 12c-13.6 7.9-18.3 25.3-10.4 38.9l12 20.8c7.9 13.6 25.3 18.2 38.9 10.4zM283.4 364.6l-20.8-12c-13.6-7.9-18.3-25.3-10.4-38.9l12-20.8c7.9-13.6 25.3-18.3 38.9-10.4l20.8 12c13.6 7.9 18.3 25.3 10.4 38.9l-12 20.8c-7.9 13.6-25.3 18.2-38.9 10.4z"
                      className="st0"/>
                <path d="M282.1 343c0 35.3 28.7 64 64 64h94c35.3 0 64-28.7 64-64v-59c0-35.3-28.7-64-64-64h-94c-35.3 0-64 28.7-64 64v59z"
                      className="st0"/>
                <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 15.9-7.1 30.5-19 42.1v.5l47 47 47-47v-.5c-11.8-11.6-19-26.2-19-42.1z"
                      className="st1"/>
                <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 4.5-.6 8.8-1.6 13l19.2 11.6c6.4 3.9 14.5 3.9 20.9 0l19.2-11.6c-1.1-4.2-1.7-8.5-1.7-13z"
                      className="st2"/>
                <path d="M433.5 176l-29.9 18.1c-6.4 3.9-14.5 3.9-20.9 0L352.8 176c-9.6-5.8-15.7-15.9-16.5-27.1L329.1 48h128L450 148.9c-.8 11.2-7 21.3-16.5 27.1z"
                      className="st3"/>
                <path d="M410.1 137.5l16-1M360.1 136.5l16 1" className="st4"/>
                <path d="M132.6 421h521" className="st5"/>
                <path d="M452.4 114.9l4.7-67h-128l5.8 81.1c4-3.5 8.6-6.4 13.6-8.6 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 .1.1 19.9 8.8 32.3 25.5z"
                      className="st6"/>
                <path d="M411.1 12c-59-24-99 31.8-99 81 0 15.3 3.9 29.7 10.7 42.3 4.8-10.9 14.1-19.8 25.7-24.8 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 0 0 40 17.5 42 50.9.3 4.3 1.5 8.4 1.8 12.5 11.2-12.7 18.2-30.5 18.2-50.3 0-19.6-10-80.6-71-80.6z"
                      className="st7"/>
                <path d="M268.3 387c0 11 9 20 20 20H498c11 0 20-9 20-20V255c0-11-9-20-20-20H288.3c-11 0-20 9-20 20v132z"
                      className="st8"/>
                <circle cx="393.1" cy="321" r="24" style={{fill: "rgb(255,0,0)"}} />
                <path d="M271.6 398c3.6 5.4 9.7 9 16.7 9H498c7 0 13.1-3.6 16.7-9H271.6z"
                      className="st10"/>
                <path d="M201.1 88.2l-39 28.6c-3 2.2-7.3.1-7.3-3.7V55.9c0-3.8 4.3-5.9 7.3-3.7l39 28.6c2.5 1.8 2.5 5.6 0 7.4zM89.7 84.5h35.8M219.9 54.5h16M690.6 198.7h-17.4v-17.4c0-4.6-3.8-8.4-8.4-8.4H652c-4.6 0-8.4 3.8-8.4 8.4v17.4h-17.4c-4.6 0-8.4 3.8-8.4 8.4V220c0 4.6 3.8 8.4 8.4 8.4h17.4v17.4c0 4.6 3.8 8.4 8.4 8.4h12.9c4.6 0 8.4-3.8 8.4-8.4v-17.4h17.4c4.6 0 8.4-3.8 8.4-8.4v-12.9c-.1-4.6-3.9-8.4-8.5-8.4zM783.3 213.6h-52.8M746.4 183.6h-29.6M84.5 298.4l34-75M152.5 298.4l-34-75M98 269h41"
                      className="st11"/>
                <g>
                  <path d="M170 260.9h32M186 244.9v32" className="st11"/>
                </g>
                <path d="M80 234H49M60 264H3M63 114.5h62.5M601.5 33.5L625 57M679 3l-54 54M552 134l50.5-50.5M560 86l22.5-22.5"
                      className="st11"/>
              </svg>
              <div className="shadow"/>
            </div>
            <div className="workshop-all">
              <p className="invest-slogan">Live webinars</p>
            </div>
            <div className="workshop-all">
              <p>Live online webinars for professionals</p>
            </div>
            <div className="workshop-rate workshops-wapper">
              {this.state.webinars.map(el => (
                <div className="main-workshop-item">
                  <div className="main-workshop-wrapper">
                    {el.provider_logo_url ?
                      <img src={el.provider_logo_url} alt="ava" className="has-ava"/> :
                      <img src={NO_AVA} alt="ava"/>
                    }
                    <div className="main-workshop-provider-info">
                      <p className="provider">PROVIDED BY</p>
                      <p className="name"> {el.provided_by}</p>
                    </div>
                    <div className="workshop-devider" />
                    <div className="workshop-title-section">
                      <p className="title">{el.title}</p>
                      <div className="price-cpd">
                        {el.cpd_hours &&
                          <p><b>CPD Hours:</b>{` ${el.how_many_hours}`}</p>
                        }
                        {el.fee &&
                          <p><b>Price: </b>{` € ${el.cost}`}</p>
                        }
                      </div>
                    </div>
                    <span onClick={() => this.redirectToOnline(el.id)} className="btn bordered empty card-online-public">DETAILS</span>
                  </div>
                </div>
              ))
              }
            </div>
            <div className="workshop-all">
              <span onClick={this.redirectWebinar} className="btn prime bordered">ALL LIVE WEBINARS</span>
            </div>
          </div>
        </section>
        {/* END Webinars */}
        {/* Online */}
        <section className="main-workshops dark-background">
          <div className="container-fluid">
            <div className="invest-holder">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 786.3 426">

                <path d="M502.9 364.6l20.8-12c13.6-7.9 18.3-25.3 10.4-38.9l-12-20.8c-7.9-13.6-25.3-18.3-38.9-10.4l-20.8 12c-13.6 7.9-18.3 25.3-10.4 38.9l12 20.8c7.9 13.6 25.3 18.2 38.9 10.4zM283.4 364.6l-20.8-12c-13.6-7.9-18.3-25.3-10.4-38.9l12-20.8c7.9-13.6 25.3-18.3 38.9-10.4l20.8 12c13.6 7.9 18.3 25.3 10.4 38.9l-12 20.8c-7.9 13.6-25.3 18.2-38.9 10.4z"
                      className="st0"/>
                <path d="M282.1 343c0 35.3 28.7 64 64 64h94c35.3 0 64-28.7 64-64v-59c0-35.3-28.7-64-64-64h-94c-35.3 0-64 28.7-64 64v59z"
                      className="st0"/>
                <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 15.9-7.1 30.5-19 42.1v.5l47 47 47-47v-.5c-11.8-11.6-19-26.2-19-42.1z"
                      className="st1"/>
                <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 4.5-.6 8.8-1.6 13l19.2 11.6c6.4 3.9 14.5 3.9 20.9 0l19.2-11.6c-1.1-4.2-1.7-8.5-1.7-13z"
                      className="st2"/>
                <path d="M433.5 176l-29.9 18.1c-6.4 3.9-14.5 3.9-20.9 0L352.8 176c-9.6-5.8-15.7-15.9-16.5-27.1L329.1 48h128L450 148.9c-.8 11.2-7 21.3-16.5 27.1z"
                      className="st3"/>
                <path d="M410.1 137.5l16-1M360.1 136.5l16 1" className="st4"/>
                <path d="M132.6 421h521" className="st5"/>
                <path d="M452.4 114.9l4.7-67h-128l5.8 81.1c4-3.5 8.6-6.4 13.6-8.6 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 .1.1 19.9 8.8 32.3 25.5z"
                      className="st6"/>
                <path d="M411.1 12c-59-24-99 31.8-99 81 0 15.3 3.9 29.7 10.7 42.3 4.8-10.9 14.1-19.8 25.7-24.8 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 0 0 40 17.5 42 50.9.3 4.3 1.5 8.4 1.8 12.5 11.2-12.7 18.2-30.5 18.2-50.3 0-19.6-10-80.6-71-80.6z"
                      className="st7"/>
                <path d="M268.3 387c0 11 9 20 20 20H498c11 0 20-9 20-20V255c0-11-9-20-20-20H288.3c-11 0-20 9-20 20v132z"
                      className="st8"/>
                <circle cx="393.1" cy="321" r="24" className="st9"/>
                <path d="M271.6 398c3.6 5.4 9.7 9 16.7 9H498c7 0 13.1-3.6 16.7-9H271.6z"
                      className="st10"/>
                <path d="M201.1 88.2l-39 28.6c-3 2.2-7.3.1-7.3-3.7V55.9c0-3.8 4.3-5.9 7.3-3.7l39 28.6c2.5 1.8 2.5 5.6 0 7.4zM89.7 84.5h35.8M219.9 54.5h16M690.6 198.7h-17.4v-17.4c0-4.6-3.8-8.4-8.4-8.4H652c-4.6 0-8.4 3.8-8.4 8.4v17.4h-17.4c-4.6 0-8.4 3.8-8.4 8.4V220c0 4.6 3.8 8.4 8.4 8.4h17.4v17.4c0 4.6 3.8 8.4 8.4 8.4h12.9c4.6 0 8.4-3.8 8.4-8.4v-17.4h17.4c4.6 0 8.4-3.8 8.4-8.4v-12.9c-.1-4.6-3.9-8.4-8.5-8.4zM783.3 213.6h-52.8M746.4 183.6h-29.6M84.5 298.4l34-75M152.5 298.4l-34-75M98 269h41"
                      className="st11"/>
                <g>
                  <path d="M170 260.9h32M186 244.9v32" className="st11"/>
                </g>
                <path d="M80 234H49M60 264H3M63 114.5h62.5M601.5 33.5L625 57M679 3l-54 54M552 134l50.5-50.5M560 86l22.5-22.5"
                      className="st11"/>
              </svg>
              <div className="shadow"/>
            </div>
            <div className="workshop-all">
              <p className="invest-slogan">Online Workshops</p>
            </div>
            <div className="workshop-all">
              <p style={{color: '#fff'}}>On demand workshops available 24/7/365 for professionals</p>
            </div>
            <div className="workshop-rate workshops-wapper">
              {this.state.online.map(el => (
                <div className="main-workshop-item">
                  <div className="main-workshop-wrapper">
                    {el.provider_logo_url ?
                      <img src={el.provider_logo_url} alt="ava" className="has-ava"/> :
                      <img src={NO_AVA} alt="ava"/>
                    }
                    <div className="main-workshop-provider-info">
                      <p className="provider">PROVIDED BY</p>
                      <p className="name"> {el.provided_by}</p>
                    </div>
                    <div className="workshop-devider" />
                    <div className="workshop-title-section">
                      <p className="title">{el.title}</p>
                      <div className="price-cpd">
                        {el.cpd_hours &&
                          <p><b>CPD Hours:</b>{` ${el.how_many_hours}`}</p>
                        }
                        {el.fee &&
                          <p><b>Price: </b>{` € ${el.cost}`}</p>
                        }
                      </div>
                    </div>
                    <span onClick={() => this.redirectToOnline(el.id)} className="btn bordered empty card-online-public">DETAILS</span>
                  </div>
                </div>
              ))
              }
            </div>
            <div className="workshop-all">
              <span onClick={this.redirectOnline} className="btn prime bordered">ALL ONLINE WORKSHOPS</span>
            </div>
          </div>
        </section>
        {/* End Online */}
        {/* PUBLIC WEBINARS */}
        <section className="main-workshops">
          <div className="container-fluid">
            {/* <header className="workshop-head" style={{marginTop: 0}}>
              <span className="workshop-head-icon">
                <img src={ragularPreview} alt=""/>
              </span>
            </header> */}

            <div className="invest-holder">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 786.3 426">

                <path d="M502.9 364.6l20.8-12c13.6-7.9 18.3-25.3 10.4-38.9l-12-20.8c-7.9-13.6-25.3-18.3-38.9-10.4l-20.8 12c-13.6 7.9-18.3 25.3-10.4 38.9l12 20.8c7.9 13.6 25.3 18.2 38.9 10.4zM283.4 364.6l-20.8-12c-13.6-7.9-18.3-25.3-10.4-38.9l12-20.8c7.9-13.6 25.3-18.3 38.9-10.4l20.8 12c13.6 7.9 18.3 25.3 10.4 38.9l-12 20.8c-7.9 13.6-25.3 18.2-38.9 10.4z"
                      className="st0"/>
                <path d="M282.1 343c0 35.3 28.7 64 64 64h94c35.3 0 64-28.7 64-64v-59c0-35.3-28.7-64-64-64h-94c-35.3 0-64 28.7-64 64v59z"
                      className="st0"/>
                <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 15.9-7.1 30.5-19 42.1v.5l47 47 47-47v-.5c-11.8-11.6-19-26.2-19-42.1z"
                      className="st1"/>
                <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 4.5-.6 8.8-1.6 13l19.2 11.6c6.4 3.9 14.5 3.9 20.9 0l19.2-11.6c-1.1-4.2-1.7-8.5-1.7-13z"
                      className="st2"/>
                <path d="M433.5 176l-29.9 18.1c-6.4 3.9-14.5 3.9-20.9 0L352.8 176c-9.6-5.8-15.7-15.9-16.5-27.1L329.1 48h128L450 148.9c-.8 11.2-7 21.3-16.5 27.1z"
                      className="st3"/>
                <path d="M410.1 137.5l16-1M360.1 136.5l16 1" className="st4"/>
                <path d="M132.6 421h521" className="st5"/>
                <path d="M452.4 114.9l4.7-67h-128l5.8 81.1c4-3.5 8.6-6.4 13.6-8.6 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 .1.1 19.9 8.8 32.3 25.5z"
                      className="st6"/>
                <path d="M411.1 12c-59-24-99 31.8-99 81 0 15.3 3.9 29.7 10.7 42.3 4.8-10.9 14.1-19.8 25.7-24.8 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 0 0 40 17.5 42 50.9.3 4.3 1.5 8.4 1.8 12.5 11.2-12.7 18.2-30.5 18.2-50.3 0-19.6-10-80.6-71-80.6z"
                      className="st7"/>
                <path d="M268.3 387c0 11 9 20 20 20H498c11 0 20-9 20-20V255c0-11-9-20-20-20H288.3c-11 0-20 9-20 20v132z"
                      className="st8"/>
                <circle cx="393.1" cy="321" r="24" style={{fill: "rgb(255,0,0)"}} />
                <path d="M271.6 398c3.6 5.4 9.7 9 16.7 9H498c7 0 13.1-3.6 16.7-9H271.6z"
                      className="st10"/>
                <path d="M201.1 88.2l-39 28.6c-3 2.2-7.3.1-7.3-3.7V55.9c0-3.8 4.3-5.9 7.3-3.7l39 28.6c2.5 1.8 2.5 5.6 0 7.4zM89.7 84.5h35.8M219.9 54.5h16M690.6 198.7h-17.4v-17.4c0-4.6-3.8-8.4-8.4-8.4H652c-4.6 0-8.4 3.8-8.4 8.4v17.4h-17.4c-4.6 0-8.4 3.8-8.4 8.4V220c0 4.6 3.8 8.4 8.4 8.4h17.4v17.4c0 4.6 3.8 8.4 8.4 8.4h12.9c4.6 0 8.4-3.8 8.4-8.4v-17.4h17.4c4.6 0 8.4-3.8 8.4-8.4v-12.9c-.1-4.6-3.9-8.4-8.5-8.4zM783.3 213.6h-52.8M746.4 183.6h-29.6M84.5 298.4l34-75M152.5 298.4l-34-75M98 269h41"
                      className="st11"/>
                <g>
                  <path d="M170 260.9h32M186 244.9v32" className="st11"/>
                </g>
                <path d="M80 234H49M60 264H3M63 114.5h62.5M601.5 33.5L625 57M679 3l-54 54M552 134l50.5-50.5M560 86l22.5-22.5"
                      className="st11"/>
              </svg>
              <div className="shadow"/>
            </div>
            <div className="workshop-all">
              <p className="invest-slogan">PUBLIC WEBINARS</p>
            </div>
            <div className="workshop-all">
              <p>Live online psychoeducational webinars for the general public</p>
            </div>
            <div className="workshop-rate workshops-wapper">
              {this.state.group.map(el => (
                <div className="main-workshop-item">
                  <div className="main-workshop-wrapper">
                    {el.provider_logo_url ?
                      <img src={el.provider_logo_url} alt="ava" className="has-ava"/> :
                      <img src={NO_AVA} alt="ava"/>
                    }
                    <div className="main-workshop-provider-info">
                      <p className="provider">PROVIDED BY</p>
                      <p className="name"> {el.provided_by}</p>
                    </div>
                    <div className="workshop-devider" />
                    <div className="workshop-title-section">
                      <p className="title">{el.title}</p>
                      <div className="price-cpd">
                        {el.modules_count &&
                          <p><b>Modules:</b>{` ${el.modules_count}`}</p>
                        }
                        {el.fee &&
                          <p><b>Price: </b>{` € ${el.cost}`}</p>
                        }
                      </div>
                    </div>
                    <span onClick={() => this.redirectToOnline(el.id)} className="btn bordered empty card-online-public">DETAILS</span>
                  </div>
                </div>
              ))
              }
            </div>
            <div className="workshop-all">
              <span onClick={this.redirectGroup} className="btn prime bordered">ALL PUBLIC WEBINARS</span>
            </div>
          </div>
        </section>
        {/* End PUBLIC WEBINARS */}
        {/* PUBLIC WORKSHOPS */}
        <section className="main-workshops">
          <div className="container-fluid">
            {/* <header className="workshop-head" style={{marginTop: 0}}>
              <span className="workshop-head-icon">
                <img src={ragularPreview} alt=""/>
              </span>
            </header> */}

            <div className="invest-holder">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 786.3 426">

                <path d="M502.9 364.6l20.8-12c13.6-7.9 18.3-25.3 10.4-38.9l-12-20.8c-7.9-13.6-25.3-18.3-38.9-10.4l-20.8 12c-13.6 7.9-18.3 25.3-10.4 38.9l12 20.8c7.9 13.6 25.3 18.2 38.9 10.4zM283.4 364.6l-20.8-12c-13.6-7.9-18.3-25.3-10.4-38.9l12-20.8c7.9-13.6 25.3-18.3 38.9-10.4l20.8 12c13.6 7.9 18.3 25.3 10.4 38.9l-12 20.8c-7.9 13.6-25.3 18.2-38.9 10.4z"
                      className="st0"/>
                <path d="M282.1 343c0 35.3 28.7 64 64 64h94c35.3 0 64-28.7 64-64v-59c0-35.3-28.7-64-64-64h-94c-35.3 0-64 28.7-64 64v59z"
                      className="st0"/>
                <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 15.9-7.1 30.5-19 42.1v.5l47 47 47-47v-.5c-11.8-11.6-19-26.2-19-42.1z"
                      className="st1"/>
                <path d="M421.1 178.4c0-2.2.1-4.3.4-6.4h-56.8c.3 2.1.4 4.2.4 6.4 0 4.5-.6 8.8-1.6 13l19.2 11.6c6.4 3.9 14.5 3.9 20.9 0l19.2-11.6c-1.1-4.2-1.7-8.5-1.7-13z"
                      className="st2"/>
                <path d="M433.5 176l-29.9 18.1c-6.4 3.9-14.5 3.9-20.9 0L352.8 176c-9.6-5.8-15.7-15.9-16.5-27.1L329.1 48h128L450 148.9c-.8 11.2-7 21.3-16.5 27.1z"
                      className="st3"/>
                <path d="M410.1 137.5l16-1M360.1 136.5l16 1" className="st4"/>
                <path d="M132.6 421h521" className="st5"/>
                <path d="M452.4 114.9l4.7-67h-128l5.8 81.1c4-3.5 8.6-6.4 13.6-8.6 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 .1.1 19.9 8.8 32.3 25.5z"
                      className="st6"/>
                <path d="M411.1 12c-59-24-99 31.8-99 81 0 15.3 3.9 29.7 10.7 42.3 4.8-10.9 14.1-19.8 25.7-24.8 0 0 16-7.8 25.2-9 2.7.3 44.4-.5 46.4-22 0 0 40 17.5 42 50.9.3 4.3 1.5 8.4 1.8 12.5 11.2-12.7 18.2-30.5 18.2-50.3 0-19.6-10-80.6-71-80.6z"
                      className="st7"/>
                <path d="M268.3 387c0 11 9 20 20 20H498c11 0 20-9 20-20V255c0-11-9-20-20-20H288.3c-11 0-20 9-20 20v132z"
                      className="st8"/>
                      {/* <circle style="stroke: rgb(255,0,0); stroke-width: 8; stroke-dasharray: none; stroke-linecap: butt; stroke-dashoffset: 0; stroke-linejoin: round; stroke-miterlimit: 4; fill: rgb(255,0,4); fill-rule: nonzero; opacity: 1;" vector-effect="non-scaling-stroke"  cx="0" cy="0" r="40" /> */}
                <circle cx="393.1" cy="321" r="24" className="st9" />
                <path d="M271.6 398c3.6 5.4 9.7 9 16.7 9H498c7 0 13.1-3.6 16.7-9H271.6z"
                      className="st10"/>
                <path d="M201.1 88.2l-39 28.6c-3 2.2-7.3.1-7.3-3.7V55.9c0-3.8 4.3-5.9 7.3-3.7l39 28.6c2.5 1.8 2.5 5.6 0 7.4zM89.7 84.5h35.8M219.9 54.5h16M690.6 198.7h-17.4v-17.4c0-4.6-3.8-8.4-8.4-8.4H652c-4.6 0-8.4 3.8-8.4 8.4v17.4h-17.4c-4.6 0-8.4 3.8-8.4 8.4V220c0 4.6 3.8 8.4 8.4 8.4h17.4v17.4c0 4.6 3.8 8.4 8.4 8.4h12.9c4.6 0 8.4-3.8 8.4-8.4v-17.4h17.4c4.6 0 8.4-3.8 8.4-8.4v-12.9c-.1-4.6-3.9-8.4-8.5-8.4zM783.3 213.6h-52.8M746.4 183.6h-29.6M84.5 298.4l34-75M152.5 298.4l-34-75M98 269h41"
                      className="st11"/>
                <g>
                  <path d="M170 260.9h32M186 244.9v32" className="st11"/>
                </g>
                <path d="M80 234H49M60 264H3M63 114.5h62.5M601.5 33.5L625 57M679 3l-54 54M552 134l50.5-50.5M560 86l22.5-22.5"
                      className="st11"/>
              </svg>
              <div className="shadow"/>
            </div>
            <div className="workshop-all">
              <p className="invest-slogan">PUBLIC WORKSHOPS</p>
            </div>
            <div className="workshop-all">
              <p>On demand psychoeducational workshops available 24/7/365 for the general public</p>
            </div>
            <div className="workshop-rate workshops-wapper">
              {this.state.public.map(el => (
                <div className="main-workshop-item">
                  <div className="main-workshop-wrapper">
                    {el.provider_logo_url ?
                      <img src={el.provider_logo_url} alt="ava" className="has-ava"/> :
                      <img src={NO_AVA} alt="ava"/>
                    }
                    <div className="main-workshop-provider-info">
                      <p className="provider">PROVIDED BY</p>
                      <p className="name"> {el.provided_by}</p>
                    </div>
                    <div className="workshop-devider" />
                    <div className="workshop-title-section">
                      <p className="title">{el.title}</p>
                      <div className="price-cpd">
                        {el.modules_count &&
                          <p><b>Modules:</b>{` ${el.modules_count}`}</p>
                        }
                        {el.fee &&
                          <p><b>Price: </b>{` € ${el.cost}`}</p>
                        }
                      </div>
                    </div>
                    <span onClick={() => this.redirectToOnline(el.id)} className="btn bordered empty card-online-public">DETAILS</span>
                  </div>
                </div>
              ))
              }
            </div>
            <div className="workshop-all">
              <span onClick={this.redirectToPublic} className="btn prime bordered">ALL PUBLIC WORKSHOPS</span>
            </div>
          </div>
        </section>
        {/* End PUBLIC WORKSHOPS */}
        {/* Organization */}
        <section className="main-workshops dark-background">
          <div className="container-fluid">
            <header className="workshop-head" style={{marginTop: 0}}>
              <span className="workshop-head-icon">
                <img src={ragularPreview} alt=""/>
              </span>
            </header>
            <div className="workshop-all">
              <p className="invest-slogan">ORGANISATIONS</p>
              <p className="organization-text">Workshops/Webinars for specific organisations</p>
              <br />
              <p className="organization-text">Do you want us to host online workshops for members of your organisation?</p>
              <p className="organization-text"><NewLinl to="/organisations-info">Click here</NewLinl> for more info or email us / call us to find out more.</p>
              <br />
              <br />
              <p className="organization-text">Phone</p>
              <p className="organization-contact-text">087 3356536</p>
              <br />
              <br />
              <p className="organization-text">E-MAIL</p>
              <p className="organization-contact-text">support@therapyacademy.ie</p>
            </div>
          </div>
        </section>
        {/* End Organization */}

        {/* <Element name="online">
        <section className="workshop-online workshop" id="OnlineWorkshop">
          <div className="container-fluid">
            <div className="row">
              <div className="col"> */}
                {/* <header className="workshop-head">
                            <span className="workshop-head-icon">
                                <svg width="80" height="60">
    <path fill="#8AA3AE"  d="M79 59.987H1c-.552 0-1-.449-1-1.003 0-.555.448-1.004 1-1.004h78c.553 0 1 .449 1 1.004 0 .554-.447 1.003-1 1.003zM58.639 49.438l-1.351.783v2.391a3.62 3.62 0 0 1-3.61 3.621H26.322a3.62 3.62 0 0 1-3.61-3.621v-2.391l-1.351-.783a5.614 5.614 0 0 1-2.624-3.43 5.63 5.63 0 0 1 .563-4.287l1.32-2.297c.522-.922 1.204-2.111 2.092-2.774v-1.322a3.616 3.616 0 0 1 3.553-3.616c1.828-2.451 4.732-2.889 7.205-2.927.916-.994 1.504-2.12 1.735-3.311l-.984-.598a5.53 5.53 0 0 1-2.637-4.33l-.08-1.136a.988.988 0 0 1-.644.283 1 1 0 0 1-.919-.525 12.711 12.711 0 0 1-1.512-6.013c0-4.315 2.146-8.663 5.341-10.819 1.813-1.225 4.798-2.343 8.775-.789 7.959.12 10.07 7.582 10.07 11.543 0 2.76-.932 5.337-2.625 7.257a.997.997 0 0 1-1.07.285 1 1 0 0 1-.485-.363l-.02.277a5.526 5.526 0 0 1-2.635 4.33l-.986.599c.232 1.191.82 2.317 1.736 3.31 2.51.044 5.391.494 7.205 2.927a3.616 3.616 0 0 1 3.553 3.616v1.322c.888.663 1.571 1.853 2.093 2.777l1.319 2.294a5.63 5.63 0 0 1 .563 4.287 5.618 5.618 0 0 1-2.624 3.43zm-35.927-9.634c-.136.229-.257.443-.353.611l-1.327 2.309a3.634 3.634 0 0 0-.363 2.764c.251.94.852 1.726 1.692 2.212l.351.204v-8.1zm10.74-8.948l-.082-.061c-1.804.047-3.143.336-4.145.911h5.379l-1.152-.85zm13.836-18.108c.209.195.414.402.613.621.044.048.09.093.133.141.172.197.339.403.498.619.031.042.07.081.1.123.017.024.022.053.037.078.524.751.951 1.6 1.174 2.557a9.46 9.46 0 0 0 .772-3.797c0-.096-.095-9.538-8.265-9.538a.997.997 0 0 1-.377-.074c-2.573-1.049-5.025-.87-7.086.522-2.667 1.8-4.458 5.479-4.458 9.155 0 1.164.19 2.319.558 3.413.201-.235.421-.456.653-.666l.001-.001.006-.005c.275-.249.575-.472.888-.681a7.95 7.95 0 0 1 1.232-.683c.701-.334 2.404-1.101 3.577-1.253a.99.99 0 0 1 .237-.002h.001c.81.041 4.792-.321 4.945-1.982a.994.994 0 0 1 .109-.359c.017-.034.043-.06.064-.092a.945.945 0 0 1 .164-.198c.014-.012.021-.031.035-.043.029-.022.063-.032.093-.051.047-.03.093-.058.144-.08.055-.023.111-.037.17-.051.034-.007.063-.025.098-.029.01-.001.03.006.041.006.027-.002.052-.014.078-.014.044 0 .087.003.131.009.065.009.267.087.552.223.467.207 1.052.549 1.674.991a12.725 12.725 0 0 1 1.408 1.141zm-.867 7.656l.371-5.257c-.021-.027-.042-.055-.064-.081a8 8 0 0 0-.586-.653l-.039-.039a11.158 11.158 0 0 0-2.032-1.556 3.272 3.272 0 0 1-.345.463 3.811 3.811 0 0 1-.438.421c-.811.664-1.891 1.04-2.91 1.263-.106.023-.214.053-.318.073-.058.011-.11.016-.167.026-.489.086-.953.141-1.343.171-.165.012-.304.018-.441.024l-.139.008c-.112.004-.19.004-.274.005l-.133.002h-.001c-.554.081-1.423.401-2.203.738-.26.112-.51.226-.734.333l-.051.023-.008.004a5.902 5.902 0 0 0-1.033.589c-.066.046-.123.1-.187.149l.233 3.293a3.524 3.524 0 0 0 1.678 2.757l1.574.957.001.001 2.322 1.412a1.672 1.672 0 0 0 .846.238c.292 0 .585-.08.846-.238l2.321-1.412.003-.002 1.573-.956a3.519 3.519 0 0 0 1.678-2.756zm-11.1 9.34l1.069.789 1.589 1.173h4.042l2.658-1.962c-.801-.968-1.375-2.036-1.702-3.164l-1.094.665a3.622 3.622 0 0 1-1.883.53 3.622 3.622 0 0 1-1.883-.53l-1.094-.665c-.327 1.128-.901 2.196-1.702 3.164zm11.311 1.049l-1.236.913h5.382c-1.006-.58-2.348-.869-4.146-.913zm8.656 18.849V35.328c0-.89-.723-1.615-1.61-1.615H26.322c-.888 0-1.61.725-1.61 1.615v17.284c0 .891.722 1.615 1.61 1.615h27.356c.887 0 1.61-.724 1.61-1.615v-2.97zm3.68-6.918l-1.326-2.307c-.096-.169-.217-.383-.354-.613v8.1l.351-.204a3.616 3.616 0 0 0 1.692-2.212 3.63 3.63 0 0 0-.363-2.764zM40 49.119c-2.279 0-4.132-1.859-4.132-4.146A4.143 4.143 0 0 1 40 40.828c2.278 0 4.132 1.859 4.132 4.145 0 2.287-1.854 4.146-4.132 4.146zm0-6.285a2.137 2.137 0 0 0-2.132 2.139c0 1.18.956 2.14 2.132 2.14 1.176 0 2.132-.96 2.132-2.14 0-1.18-.956-2.139-2.132-2.139zm2.281-22.854a1.001 1.001 0 0 1-1.06-.939 1.001 1.001 0 0 1 .935-1.064l2.088-.131c.562-.046 1.025.386 1.061.939a1.003 1.003 0 0 1-.936 1.064l-2.088.131zm-4.499.002l-.063-.002-2.088-.131a1.003 1.003 0 0 1-.936-1.064.996.996 0 0 1 1.061-.939l2.088.131c.551.034.97.511.935 1.064a1.001 1.001 0 0 1-.997.941z"/>
</svg>

                            </span>
                  <h3 className="workshop-head-title">ONLINE WORKSHOPS</h3>
                </header> */}
              {/* </div>
            </div>
            <div className="workshop-rate">

              {this.state.michael.map(el =>
                <div style={{boxShadow: "0 2px 30px 0 rgba(0, 0, 0, 0.71)"}} className="card online" key={el.id} onClick={() => this.redirectToOnline(el.id)} >
                  <div className="avatar-index-wrap">

                  <div className="card-avatar-wrap">
                    <div className="card-avatar-wrap-inner">
                      {el.provider_logo_url ?
                        <img src={el.provider_logo_url} alt="ava" className="has-ava"/> :
                        <img src={NO_AVA} alt="ava"/> }
                    </div>
                    <p className="provide">PROVIDED BY</p>
                    <p className="name"> {el.provided_by}</p>
                  </div>


                  <div className="card-top-wrap">
                    <div className="card-head top" style={{wordBreak: 'break-word'}}>
                      <p className="card-title">{el.title}</p>

                    </div>
                    <div className="card-content">
                      <p className="card-desc">{el.summary ? el.summary : this.shortDescription(el.description)}</p>
                    </div>
                  </div>
                  </div>
                  <div className="card-footer">
                    <div className="card-footer-top">
                      <ul className="suitableFor">
                        <li key="wdw"> <p className="card-info-title">Suitable for: </p></li>
                        {el.target_audience.map( (element,i) =>
                          <li key={i}><span style={{color: '#1589c6', marginLeft: 1}}>{element}</span></li>
                        )}
                      </ul>
                    </div>
                    <div className="card-footer-bottom">
                      <ul className="card-info" style={{display: 'block'}}>
                        <li>
                          <p className="card-info-title">
                            Modules:
                            <span className="card-info-sub" style={{marginLeft: 8, color: '#1589c6'}}>{el.modules_count || 0}</span>
                          </p>
                        </li>
                        <li>
                          <p className="card-info-title">
                            CPD Hours:
                            <span className="card-info-sub" style={{marginLeft: 8}}>
                              {el.how_many_hours || 'Check with provider' }
                            </span>
                          </p>
                        </li>
                        <li>
                          <p className="card-info-title">
                            Price:
                            <span className="card-info-sub" style={{marginLeft: 8, color: '#1589c6'}}>
                              <span className="currency euro"/>
                              {el.cost}
                              </span>
                          </p>
                        </li>
                      </ul>
                      <span className="btn bordered empty card-btn card-more card-btn">
                        details
                      </span>
                    </div>
                  </div>
                </div>

              )}



              {this.state.online.map(el =>
                <div style={{boxShadow: "0 2px 30px 0 rgba(0, 0, 0, 0.71)"}} className="card online max-width" key={el.id} onClick={() => this.redirectToOnline(el.id)}>

                  <div className="avatar-index-wrap">
                  <div className="card-avatar-wrap">
                    <div className="card-avatar-wrap-inner">
                      {el.provider_logo_url ?
                        <img src={el.provider_logo_url} alt="ava" className="has-ava"/> :
                        <img src={NO_AVA} alt="ava"/> }
                    </div>
                    <p className="provide">PROVIDED BY</p>
                    <p className="name"> {el.provided_by}</p>
                  </div>


                  <div className="card-top-wrap">
                    <div className="card-head top" style={{wordBreak: 'break-word'}}>
                      <p className="card-title">{el.title}</p>

                    </div>
                    <div className="card-content">
                      <p className="card-desc">{el.summary ? el.summary : this.shortDescription(el.description)}</p>
                    </div>
                  </div>
                  </div>
                  <div className="card-footer">
                    <div className="card-footer-top">
                      <ul className="suitableFor">
                        <li key="wdw"> <p className="card-info-title">Suitable for: </p></li>
                        {el.target_audience.map( (element,i) =>
                          <li key={i}><span style={{color: '#1589c6', marginLeft: 1}}>{element}</span></li>
                        )}
                      </ul>
                    </div>
                    <div className="card-footer-bottom">
                      <ul className="card-info" style={{display: 'block'}}>
                        <li>
                          <p className="card-info-title">
                            Modules:
                            <span className="card-info-sub"
                                  style={{marginLeft: 8, color: '#1589c6'}}>{el.modules_count || 0}</span>
                          </p>
                        </li>
                        <li>
                          <p className="card-info-title">
                            CPD Hours:
                            <span className="card-info-sub" style={{marginLeft: 8, color: '#1589c6'}}>
                              {el.how_many_hours || 'Check with provider'}
                            </span>
                          </p>
                        </li>
                        <li>
                          <p className="card-info-title">
                            Price:
                            <span className="card-info-sub" style={{marginLeft: 8, color: '#1589c6'}}>
                              <span className="currency euro"/>
                              {el.cost}
                              </span>
                          </p>
                        </li>
                      </ul>
                      <span  className="btn bordered empty card-btn card-more card-btn">
                        details
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {this.state.workshops.map(el =>
                <div style={{boxShadow: "0 2px 30px 0 rgba(0, 0, 0, 0.71)"}} className="card online" key={el.id} onClick={() => this.redirectToOnline(el.id)} >
                  <div className="avatar-index-wrap">

                  <div className="card-avatar-wrap">
                    <div className="card-avatar-wrap-inner">
                      {el.provider_logo_url ?
                        <img src={el.provider_logo_url} alt="ava" className="has-ava"/> :
                        <img src={NO_AVA} alt="ava"/> }
                    </div>
                    <p className="provide">PROVIDED BY</p>
                    <p className="name"> {el.provided_by}</p>
                  </div>


                  <div className="card-top-wrap">
                    <div className="card-head top" style={{wordBreak: 'break-word'}}>
                      <p className="card-title">{el.title}</p>
                      {el.workshop_type === 'live' ?
                        <div style={{display: 'flex', alignItems: 'center'}}>
                          <p>LIVE</p>
                          <img src={webinar_icon} style={{width: '25px', marginLeft: '5px'}} />
                        </div> : null
                      }

                    </div>
                    <div className="card-content">
                      <p className="card-desc">{el.summary ? el.summary : this.shortDescription(el.description)}</p>
                    </div>
                  </div>
                  </div>
                  <div className="card-footer">
                    <div className="card-footer-top">
                      {el.start_date ?
                        <span className="regular-workshop-venue-data-holder" style={{maxHeight: '25px'}}>
                          <span className="date">{`${moment(workshop.start_date).format('D MMM`YY')} - ${moment(workshop.end_date).format('D MMM`YY')}`}</span>
                          <span className="card-head-date">
                            {el.start_time &&
                              [moment(el.start_time).format('HH:mm'), '-']
                            }

                            {el.end_time &&
                              moment(el.end_time).format('HH:mm')
                            }
                            </span>
                        </span> : null
                      }
                      <ul className="suitableFor">
                        <li key="wdw"> <p className="card-info-title">Suitable for: </p></li>
                        {el.target_audience.map( (element,i) =>
                          <li key={i}><span style={{color: '#1589c6', marginLeft: 1}}>{element}</span></li>
                        )}
                      </ul>
                    </div>
                    <div className="card-footer-bottom">
                      <ul className="card-info" style={{display: 'block'}}>
                        <li>
                          <p className="card-info-title">
                            Modules:
                            <span className="card-info-sub" style={{marginLeft: 8, color: '#1589c6'}}>{el.modules_count || 0}</span>
                          </p>
                        </li>
                        <li>
                          <p className="card-info-title">
                            CPD Hours:
                            <span className="card-info-sub" style={{marginLeft: 8}}>
                              {el.how_many_hours || 'Check with provider' }
                            </span>
                          </p>
                        </li>
                        <li>
                          <p className="card-info-title">
                            Price:
                            <span className="card-info-sub" style={{marginLeft: 8, color: '#1589c6'}}>
                              <span className="currency euro"/>
                              {el.cost}
                              </span>
                          </p>
                        </li>
                      </ul>
                      <span className="btn bordered empty card-btn card-more card-btn">
                        details
                      </span>
                    </div>
                  </div>
                </div>

              )}

            </div>
            <div className="workshop-all">
              <NewLinl to={ONLINE_WORKSHOPS} className="btn prime bordered">ALL ONLINE WORKSHOPS</NewLinl>
            </div>
          </div>
        </section>
        </Element> */}
        <section className="workshop-regular workshop">
          <div className="container-fluid">
            <div className="row">
              <div className="col">
                <header className="workshop-head">
                            <span className="workshop-head-icon">

                              <img src={ragularPreview} alt=""/>

                            </span>
                  <h3 className="workshop-head-title">regular WORKSHOPS</h3>
                  <br />
                  <h3>Traditional in person workshops</h3>
                </header>
              </div>
            </div>
            <div className="workshop-rate workshops-wapper">

              { this.state.regular.map(el =>
                <div className="card regular main-workshop-item">
                  <div className="main-workshop-wrapper">
                    {el.provider_logo_url ?
                      <img src={el.provider_logo_url} alt="ava" className="has-ava"/> :
                      <img src={NO_AVA} alt="ava"/>
                    }
                    <div className="main-workshop-provider-info">
                      <p className="provider">PROVIDED BY</p>
                      <p className="name"> {el.provided_by}</p>
                    </div>
                    <div className="workshop-devider" />
                      <div className="workshop-title-section">
                        <div className="card-head-top">
                        <span className="card-head-date">{moment(el.start_date).format('D MMM`YY')}</span>
                        <span className="card-head-place">
                        <i className="ic-map-ico"/>
                          {el.venue_county}
                        </span>
                        </div>
                        <p className="title" style={{color: '#00c0c3'}}>{el.title}</p>
                        <div className="card-content">
                          <p className="card-desc">{el.summary ? el.summary : this.shortDescription(el.description)}</p>
                        </div>
                        <div className="card-footer-top">
                          <ul className="suitableFor">
                            <li key="wdw"> <p className="card-info-title">Suitable for: </p></li>
                            {el.target_audience.map( (element,i) =>
                              <li key={i}><span style={{color: '#00c0c3', marginLeft: 1}}>{element}</span></li>
                            )}
                          </ul>
                        </div>
                        <div className="price-cpd">
                          {el.modules_count &&
                            <p><b>Modules:</b>{` ${el.modules_count}`}</p>
                          }
                          <p><b>CPD Hours: </b>{el.how_many_hours || 'Check with provider'}</p>
                          {el.fee &&
                            <p><b>Price: </b>{` € ${el.cost}`}</p>
                          }
                        </div>
                    </div>
                    <span onClick={() => this.redirectToRegular(el.id)} className="btn bordered empty card-regular">DETAILS</span>
                  </div>
                </div>
                // <div className="card main-workshop-item" key={el.id} onClick={() => this.redirectToRegular(el.id)}>
                //   <div className="card-top-wrap">
                //     <div className="card-head">
                //       <div className="card-head-top">
                //         <span className="card-head-date">{moment(el.start_date).format('D MMM`YY')}</span>
                //         <span className="card-head-place">
                //         <i className="ic-map-ico"/>
                //           {el.venue_county}
                //         </span>
                //       </div>
                //       <p className="card-title" style={{color: '#00c0c3'}}>{el.title}</p>
                //     </div>
                //     <div className="card-content">
                //       <p className="card-desc">{el.summary ? el.summary : this.shortDescription(el.description)}</p>
                //     </div>
                //   </div>
                //   <div className="card-footer">
                //     <div className="card-footer-top">
                //       <ul className="suitableFor">
                //         <li key="wdw"> <p className="card-info-title">Suitable for: </p></li>
                //         {el.target_audience.map( (element,i) =>
                //           <li key={i}><span style={{color: '#00c0c3', marginLeft: 1}}>{element}</span></li>
                //         )}
                //       </ul>
                //     </div>
                //     <div className="card-footer-bottom">
                //       <ul className="card-info" style={{display: 'block'}}>
                //         <li>
                //           <p className="card-info-title">
                //             CPD Hours:
                //             <span className="card-info-sub" style={{marginLeft: 8}}>
                //               {el.how_many_hours || 'Check with provider'}
                //             </span>
                //           </p>
                //         </li>
                //         <li>
                //           <p className="card-info-title">
                //             PRICE:
                //             <span className="card-info-sub" style={{marginLeft: 8}}>
                //               <span className="currency euro"/>
                //               {el.cost || 0}
                //               </span>
                //           </p>
                //         </li>
                //       </ul>
                //       <span className="btn bordered empty card-btn card-more card-btn">
                //         details
                //       </span>
                //     </div>
                //   </div>
                // </div>
              )
              }

            </div>
            <div className="workshop-all">
              <NewLinl to="/regular_workshops" className="btn bordered blue">ALL REGULAR WORKSHOPS</NewLinl>
            </div>
          </div>
        </section>
        {/* <section className="invest" style={{backgroundColor: 'white'}}>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
                <div className="invest-inner">
                  <h1 className="invest-title">invest in yourself</h1>
                  <div className="invest-professions">
                    <p>Counsellors / Psychotherapists / Psychologists / Psychiatrists / Supervisors</p> */}
                    {/* <li>Psychotherapists</li>
                    <li>Psychologists</li>
                    <li>Psychiatrists</li>
                    <li>Supervisors</li> */}
                  {/* </div>
                  <p className="invest-hours" style={{color: 'rgba(0, 0, 0, 0.56)'}}>ACHIEVE CPD HOURS</p>
                </div>
              </div>
            </div>
          </div>
        </section> */}
        <section className="know">
          <div className="know-inner">
            <h2 className="know-title">...Do you...</h2>
            <div className="know-slogan-holder">
              <div className="left-slogan">
                <span>organise</span>
                <span>Workshops</span>
              </div>
              <div className="right-slogan">
                <span>attend</span>
                <span>workshops</span>
              </div>
            </div>
            <div className="know-desc-holder">
              <p className="know-main-desc">Would you like to add them to Therapy Academy?</p>
            </div>
            <div className="btn-holder">
              <ul>
                <li>
              <NewLinl to="/create_course_online" className="btn empty bordered white">CREATE YOUR COURSE ONLINE - it’s FREE</NewLinl>
                </li>
                {/* <li className="main-about-us">  <NewLinl to="/aboutus">
                  <span>
                  Learn More
                </span></NewLinl>
                </li> */}
              </ul>
            </div>
          </div>
        </section>
        { this.props.user.userLoggedIn()  ||
          <section className="about-service">
            <div className="about-service-inner">

              <p className="about-service-text">
                If you are interested in Therapy Academy and want to keep updated with the latest course
                information and events, click Sign Up
              </p>
                <div className="btn-holder">
                  <NewLinl to="/newuser/signup" className="btn empty bordered grey">Sign Up</NewLinl>
                </div>
            </div>
          </section>
        }
      </main>
    );
  }
}


const GALO4KA = (<svg xmlns="http://www.w3.org/2000/svg" width="13" height="10">
  <path fill="#1EA2E8" fillRule="evenodd"
        d="M10.753.82l1.556 1.571-7.26 7.333L.383 5.01l1.555-1.571 3.111 3.143L10.753.82z"/>
</svg>);


const KPECTUK = ( <svg  width="13" height="10">
  <path fill="#FF524F" fillRule="evenodd" d="M2.292.759L.947 2.104l2.7 2.7-2.7 2.701L2.292 8.85l2.701-2.701 2.7 2.701 1.346-1.345-2.701-2.701 2.701-2.7L7.693.759l-2.7 2.7-2.701-2.7"/>
</svg>);



// WEBPACK FOOTER //
// ./src/components/Index.jsx